@if (isAdmin && bookingId) {
  <div class="booking-id-text">
    {{shortenedBookingId}}
  </div>
}

